"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../helpers/api.js");
var _createAction = require("../helpers/createAction.js");
var _constants = require("../constants");
var QuestionBanks = /*#__PURE__*/_createClass(function QuestionBanks(api, performance, browser) {
  var _this = this;
  _classCallCheck(this, QuestionBanks);
  this.getQuestionBankFetchKey = function (questionBankId) {
    return "question-banks/".concat(questionBankId);
  };
  this.questionBankFetch = (0, _createAction.createApiRequestAction)({
    getKey: this.getQuestionBankFetchKey,
    request: function request(getState, questionBankId) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/question_banks/").concat(questionBankId));
    },
    loadingConstant: _constants.QUESTION_BANK_LOADING,
    loadedConstant: _constants.QUESTION_BANK_FETCHED,
    errorConstant: _constants.QUESTION_BANK_ERROR
  });
  this.getQuestionBanksFetchKey = function () {
    return "question-banks/all";
  };
  this.questionBanksFetch = (0, _createAction.createApiRequestAction)({
    getKey: this.getQuestionBanksFetchKey,
    request: function request(getState) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/question_banks"));
    },
    loadingConstant: _constants.QUESTION_BANKS_FETCHED,
    loadedConstant: _constants.QUESTION_BANKS_FETCHED,
    errorConstant: _constants.QUESTION_BANK_ERROR
  });
  this.getQuestionBankFetchSubjectsKey = function (questionBankId) {
    return "question-bank-subjects-fetch/".concat(questionBankId);
  };
  this.questionBankFetchSubjects = (0, _createAction.createApiRequestAction)({
    getKey: this.getQuestionBankFetchSubjectsKey,
    request: function request(getState, questionBankId, userIdArg) {
      var userId = userIdArg || getState().session.get('current_user_id', 0);
      return _this.api.get("users/".concat(userId, "/question_banks/").concat(questionBankId, "/subjects"));
    },
    loadingConstant: _constants.QUESTION_BANK_SUBJECTS_FETCHING,
    loadedConstant: _constants.QUESTION_BANK_SUBJECTS_FETCHED,
    errorConstant: _constants.QUESTION_BANK_ERROR
  });
  this.getQuestionBankSelectKey = function (questionBankId) {
    return "question-bank-select/".concat(questionBankId);
  };
  this.questionBankSelect = (0, _createAction.createApiRequestAction)({
    getKey: this.getQuestionBankSelectKey,
    request: function request(getState, questionBankId, userIdArg) {
      var userId = userIdArg || getState().session.get('current_user_id', 0);
      return _this.api.put("users/".concat(userId, "/question_banks/").concat(questionBankId, "/select"));
    },
    loadingConstant: _constants.QUESTION_BANK_SELECTING,
    loadedConstant: _constants.QUESTION_BANK_SELECTED,
    errorConstant: _constants.QUESTION_BANK_ERROR,
    successCallback: function successCallback(dispatch, getState, response, questionBankId, userIdArg) {
      var fetchRelationships = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
      var userId = userIdArg || getState().session.get('current_user_id', 0);
      if (_this.browser) {
        dispatch(_this.questionBankFetchSubjects(questionBankId, userId));
      }
      if (fetchRelationships) dispatch(_this.performance.performanceQuestionsFetch(questionBankId, userId));
    }
  });
  this.getQBNamesKey = function () {
    return 'question_banks/names';
  };
  this.getQuestionBankNames = (0, _createAction.createApiRequestAction)({
    getKey: this.getQBNamesKey,
    request: function request(getState) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/question_banks/names"));
    },
    loadingConstant: _constants.QUESTION_BANK_NAMES_FETCHING,
    loadedConstant: _constants.QUESTION_BANK_NAMES_FETCHED,
    errorConstant: _constants.QUESTION_BANK_NAMES_ERROR
  });
  this.api = api;
  this.performance = performance;
  this.browser = browser;
});
;
var _default = exports.default = QuestionBanks;